import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

// Actions
import { actions as cmsActions } from 'modules/cms/actions'
import { actions as staticpagesActions } from 'modules/staticpages/actions'

// Components
import { StreamField } from 'components/staticpages/streamfield'
import SEO from 'components/base/seo'
import ThemeHelper from 'components/base/themehelper'

// Hooks
import { usePages } from 'modules/entities/hooks'
import { useRequest } from 'modules/requests/hooks'

// Types
import { Dispatch, GetState } from 'types'

export const loadInitialData = () => async (dispatch: Dispatch, getState: GetState) => {
  return dispatch(staticpagesActions.loadPageByPath('frontpage')).then(() => {
    const state = getState()
    const { pages } = state.entities
    const pageList = Object.keys(pages).map(id => pages[id])
    if (pageList && pageList.length) {
      const pagesToLoad = pageList[0].content.reduce((agg, content) => {
        if (content.type === 'hero_article') {
          const articleId = (content.value.hero_articles && content.value.hero_articles[0].article) || 0
          return [...agg, dispatch(cmsActions.fetchArticlesByIds([articleId]))]
        }
        return agg
      }, [])
      return pagesToLoad
    }
    return null
  })
}

const FrontPage = () => {
  const dispatch = useDispatch()

  const slug = 'frontpage'
  const pages = usePages()
  const page =
    pages &&
    Object.keys(pages)
      .map(id => pages[id])
      .find(p => p.meta.slug === slug)

  const request = useRequest('FETCH_STATIC_PAGE', slug)
  useEffect(() => {
    if (!page && !request.isLoading && !request.hasError) {
      dispatch(staticpagesActions.loadPageByPath(slug))
    }
  }, [slug, request]) // eslint-disable-line
  return (
    <>
      <SEO />
      {page && page?.theme && <ThemeHelper theme={page.theme} />}
      {page && page?.content && <StreamField blocks={page?.content} />}
    </>
  )
}

export default FrontPage
